import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import _initializerDefineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _applyDecoratedDescriptor from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _class, _descriptor, _descriptor2, _descriptor3;

import { observable, runInAction, computed, makeObservable, action } from "mobx";
import { PlatformType } from "@dp/common";
var UnavailableItemsModel = (_class = /*#__PURE__*/function () {
  function UnavailableItemsModel(platformUtil) {
    _classCallCheck(this, UnavailableItemsModel);

    _initializerDefineProperty(this, "_appAttributes", _descriptor, this);

    _initializerDefineProperty(this, "_unavailableProducts", _descriptor2, this);

    _initializerDefineProperty(this, "_displayUnavailableItemIssueModal", _descriptor3, this);

    _defineProperty(this, "platformUtil", void 0);

    this.platformUtil = platformUtil;
    this._displayUnavailableItemIssueModal = false;
    this._unavailableProducts = null;
    makeObservable(this);
  }

  _createClass(UnavailableItemsModel, [{
    key: "setAppAttributes",
    value: function setAppAttributes(_appAttributes) {
      var _this = this;

      runInAction(function () {
        _this._appAttributes = _appAttributes;
      });
    }
  }, {
    key: "submitErrorHandler",
    value: function submitErrorHandler(errObj) {
      var _errObj$errors;

      var handled = false;
      var parsed = errObj === null || errObj === void 0 ? void 0 : (_errObj$errors = errObj.errors) === null || _errObj$errors === void 0 ? void 0 : _errObj$errors[0];
      var errorMessage = parsed === null || parsed === void 0 ? void 0 : parsed.message;
      var unAvailableItems = parsed === null || parsed === void 0 ? void 0 : parsed.unavailableItems;
      var productIds = [];
      var commerceIDs = [];

      if (errorMessage && unAvailableItems) {
        unAvailableItems.forEach(function (item) {
          productIds.push(item.productId);
          commerceIDs.push(item.id);
        });
        this.setUnavailableProducts(unAvailableItems, errorMessage);
        this.setDisplayUnavailableItemIssueModal(true);

        if (this.platformUtil.PLATFORM_TYPE === PlatformType.APP) {
          this.platformUtil.navigateToRoute("/Cart");
        }

        handled = true;
      }

      return handled;
    }
  }, {
    key: "setUnavailableProducts",
    value: function setUnavailableProducts(unAvailableItems, errorMessage) {
      try {
        if (unAvailableItems) {
          this._unavailableProducts = {
            unAvailableItems: unAvailableItems,
            errorMessage: errorMessage
          };
        } else {
          this._unavailableProducts = null;
        }
      } catch (error) {
        this._unavailableProducts = null;
      }
    }
  }, {
    key: "setDisplayUnavailableItemIssueModal",
    value: function setDisplayUnavailableItemIssueModal(displayUnavailableItemIssueModal) {
      this._displayUnavailableItemIssueModal = displayUnavailableItemIssueModal;
    }
  }, {
    key: "unavailableProducts",
    get: function get() {
      return this._unavailableProducts;
    }
  }, {
    key: "displayUnavailableItemIssueModal",
    get: function get() {
      return this._displayUnavailableItemIssueModal;
    }
  }, {
    key: "productsID",
    get: function get() {
      var _this$unavailableProd, _this$unavailableProd2;

      return (_this$unavailableProd = this.unavailableProducts) === null || _this$unavailableProd === void 0 ? void 0 : (_this$unavailableProd2 = _this$unavailableProd.unAvailableItems) === null || _this$unavailableProd2 === void 0 ? void 0 : _this$unavailableProd2.map(function (product) {
        return product === null || product === void 0 ? void 0 : product.productId;
      });
    }
  }]);

  return UnavailableItemsModel;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "_appAttributes", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_unavailableProducts", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "_displayUnavailableItemIssueModal", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "unavailableProducts", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "unavailableProducts"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setUnavailableProducts", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setUnavailableProducts"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "displayUnavailableItemIssueModal", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "displayUnavailableItemIssueModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "productsID", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "productsID"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setDisplayUnavailableItemIssueModal", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setDisplayUnavailableItemIssueModal"), _class.prototype)), _class);
export { UnavailableItemsModel as default };